export interface Apikeys {
  status: string;
  google_oauth_client_id?: string;
  google_oauth_client_secret?: string;
  google_oauth_ios_client_id?: string;
  stripe_pk_test?: string;
  stripe_pk_live?: string;
  gtag_config?: string;
  local_gtag_config?: string;
  /** Maps JavaScript / Places API (New) browser key. */
  google_maps_api_key?: string;
  sound_api_reg_key?: string;
  cloudflare_api_token?: string;
  /** Public string keys, plus JSON object blobs (e.g. fcm_google_services_json). */
  [key: string]: string | Record<string, unknown> | unknown[] | undefined;
}

export const apikeys: Apikeys = {"status":"success","google_maps_api_key":"AIzaSyBgCZl52ME-7c35aMNs4f6cHPz2GoZ2BZU","google_photos_environment":"development","cloudflare_environment":"test","cloudflare_base_url":"https://api.cloudflare.com/client/v4","namecheap_environment":"sandbox","preferred_registrar":"cloudflare","etransfer_imap_host":"imap.gmail.com"};
